import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: `Привязка секторов диспетчера для пользователя (${ _ctx.user.name })`,
    "is-confirm": false,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        class: "w-full",
        placeholder: "Сектор диспетчера",
        "is-invalid": _ctx.state_form$.sectors.$error,
        "validation-errors": _ctx.state_form$.sectors.$errors,
        loading: _ctx.data_state.dispatchers_sectors.is_loading,
        failed: _ctx.data_state.dispatchers_sectors.is_failed,
        options: _ctx.data_state.dispatchers_sectors.list,
        "error-text": "При получении списка секторов диспетчера произошла ошибка",
        multiselect: "",
        value: _ctx.state.sectors,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sectors) = $event)),
        onRefresh: _ctx.loadDispatchersSectors
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onCancel", "onConfirm"]))
}